import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { SxProps, Theme } from '@mui/material';

type Props = {
    title: string;
    onClick: any;
    startIcon?: JSX.Element | string | undefined;
    endIcon?: JSX.Element | string | undefined;
    sx?: object | undefined;
    fullWidth?: false | boolean;
    disabled?: false | boolean;
    loading?: false | boolean;
    loadingPosition?: 'start' | 'end' | 'center';
    variant?: 'text' | 'outlined' | 'contained' | undefined;
    textSx?: SxProps<Theme> | undefined;
    tooltip?: string;
};

const LoadingButtonGeneral = ({
    title,
    onClick,
    startIcon,
    endIcon,
    sx,
    fullWidth,
    disabled,
    loading,
    loadingPosition,
    variant = 'contained',
    textSx,
    tooltip,
}: Props) => {
    const button = (
        <LoadingButton
            loading={loading}
            type="submit"
            fullWidth={fullWidth}
            onClick={onClick}
            variant={variant}
            startIcon={startIcon !== undefined ? startIcon : null}
            endIcon={endIcon !== undefined ? endIcon : null}
            loadingPosition={loadingPosition}
            disabled={disabled}
            sx={sx}
        >
            <Typography
                component="div"
                sx={{
                    color:
                        variant === 'outlined'
                            ? 'primary.main'
                            : 'primary.contrastText',
                    ...textSx,
                }}
            >
                {title}
            </Typography>
        </LoadingButton>
    );

    if (disabled && tooltip && tooltip.length > 0) {
        return (
            <Tooltip title={tooltip}>
                <span style={{ display: 'inline-block' }}>{button}</span>
            </Tooltip>
        );
    }

    return button;
};

export default LoadingButtonGeneral;
